import React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';

import { cn } from 'src/component/ds/utils';

/* "Checkbox - Vega" in Figma: 16x16 at 4px radius -- the only component that
 * isn't --ds-radius. */
const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'ds-group ds-peer ds-h-4 ds-w-4 ds-shrink-0 ds-rounded-[4px]',
      'ds-border ds-border-input ds-bg-background ds-shadow-ds-2xs',
      'focus-visible:ds-outline-none focus-visible:ds-shadow-ds-focus',
      'disabled:ds-cursor-default disabled:ds-opacity-50',
      'data-[state=checked]:ds-bg-primary data-[state=checked]:ds-border-primary',
      'data-[state=checked]:ds-text-primary-foreground',
      'data-[state=indeterminate]:ds-bg-primary data-[state=indeterminate]:ds-border-primary',
      'data-[state=indeterminate]:ds-text-primary-foreground',
      'aria-[invalid=true]:ds-border-destructive',
      'aria-[invalid=true]:data-[state=checked]:ds-bg-destructive',
      'aria-[invalid=true]:data-[state=indeterminate]:ds-bg-destructive',
      'aria-[invalid=true]:focus-visible:ds-shadow-ds-focus-error',
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className='ds-flex ds-h-full ds-w-full ds-items-center ds-justify-center ds-text-current'>
      <svg
        aria-hidden='true'
        className='ds-h-[7.58px] ds-w-[10.5px] group-data-[state=indeterminate]:ds-hidden'
        viewBox='0 0 10.5 7.58'
        fill='currentColor'
      >
        <path d='M9.50419 0.170854C9.73199 -0.0569515 10.1013 -0.0569514 10.3291 0.170854C10.5569 0.39866 10.5569 0.767918 10.3291 0.995724L3.91239 7.41239C3.68459 7.6402 3.31533 7.6402 3.08752 7.41239L0.170854 4.49572C-0.0569515 4.26792 -0.0569515 3.89866 0.170854 3.67085C0.39866 3.44305 0.767918 3.44305 0.995724 3.67085L3.49996 6.17509L9.50419 0.170854Z' />
      </svg>
      <svg
        aria-hidden='true'
        className='ds-hidden ds-h-[1.17px] ds-w-[9.33px] group-data-[state=indeterminate]:ds-block'
        viewBox='0 0 9.33 1.17'
        fill='currentColor'
      >
        <rect width='9.33' height='1.17' rx='0.583' />
      </svg>
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
